import React from 'react'
import { FiCheckCircle } from '@react-icons/all-files/fi/FiCheckCircle'
import { FiGrid } from '@react-icons/all-files/fi/FiGrid'
import { FiMail } from '@react-icons/all-files/fi/FiMail'
import Action from '../primitives/Action'
import Container from '../foundations/Container'
import styles from './ClosingActionBand.module.scss'

const toClosingConversionKey = conversionKey => {
  if (!conversionKey) return undefined
  if (conversionKey.includes('.closing.') || conversionKey.includes('.closing-action.')) return conversionKey
  return conversionKey.includes('.hero.')
    ? conversionKey.replace('.hero.', '.closing.')
    : `${conversionKey}.closing`
}

const ClosingAction = ({ action, variant }) => {
  if (!action?.label) return null

  return (
    <Action
      dataConversionChannel={action.channel}
      dataConversionKey={action.closingConversionKey || toClosingConversionKey(action.conversionKey)}
      dataConversionLocation='closing-action'
      dataConversionSalesPath={action.salesPath}
      external={action.external}
      focusTargetOnNavigate={action.focusTargetOnNavigate}
      href={action.href}
      icon={action.icon}
      onClick={action.onClick}
      size='large'
      variant={variant}
      className={styles.action}
    >
      {action.label}
    </Action>
  )
}

const ClosingActionBand = ({
  ariaLabel = 'Planning options',
  description = 'Work with an AV producer or compare rental equipment and pricing online.',
  eyebrow = 'Choose your next step',
  heading = 'Ready to plan your event?',
  headingId = 'homepage-closing-action-heading',
  onBrowse,
  onQuote,
  primaryAction,
  proofItems = [],
  secondaryAction
}) => {
  const resolvedPrimaryAction = primaryAction || {
    label: 'Request a Production Quote',
    icon: FiMail,
    conversionKey: 'homepage.closing-action.quote',
    channel: 'quote',
    salesPath: 'managed',
    onClick: onQuote
  }
  const resolvedSecondaryAction = secondaryAction || {
    label: 'Browse AV Equipment',
    href: '/#categories',
    icon: FiGrid,
    conversionKey: 'homepage.closing-action.catalog',
    channel: 'rental',
    salesPath: 'self_service',
    onClick: onBrowse
  }

  return (
    <section className={styles.section} aria-labelledby={headingId}>
      <Container width='wide' className={styles.container}>
        <div className={styles.copy}>
          <span className={styles.eyebrow}>{eyebrow}</span>
          <h2 id={headingId}>{heading}</h2>
          <p>{description}</p>
          {proofItems.length > 0 && (
            <ul className={styles.proof} aria-label='Proof available on this page'>
              {proofItems.map(item => (
                <li key={item}>
                  <FiCheckCircle aria-hidden='true' />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          )}
        </div>

        <div className={styles.actions} aria-label={ariaLabel}>
          <ClosingAction action={resolvedPrimaryAction} variant='primary' />
          <ClosingAction action={resolvedSecondaryAction} variant='darkSecondary' />
        </div>
      </Container>
    </section>
  )
}

export default ClosingActionBand
